// initial state
const state = () => ({
    artists: []
})

// getters
const getters = {
}

// actions
const actions = {
    getArtists: async({ commit }) => {
        let { data } = await axios.get('artist');
        commit('setArtists', data);
    },

    updateArtist: async({ state, commit }, artist) => {
        console.log('updateArtist', artist, artist.name);
        let { data } = await axios.put('artist/' + artist.id, artist);
        // commit('setArtists', data);
    },

    storeArtist: async({ state, commit }, artist) => {
        console.log('storeArtist', artist);
        let { data } = await axios.post('artist', artist);
        // commit('setArtists', data);
    },
}

// mutations
const mutations = {
    setArtists(state, payload) {
        state.artists = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
